<template>
  <div ref="mapContainer" :class="$style.map"></div>
</template>

<script>
export default {
  props: {
    points: Array,
  },

  data() {
    return {
      map: undefined,
      pointLayers: [],
    };
  },

  mounted() {
    this.reload();
  },

  methods: {
    reload() {
      if (this.map) {
        this.map.remove();
      }

      setTimeout(() => {
        const L = window.L;
        this.map = L.map(this.$refs.mapContainer).setView([0, 0], 2);
        L.tileLayer("http://{s}.tile.osm.org/{z}/{x}/{y}.png", {
          attribution: `&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors`,
          noWrap: true,
        }).addTo(this.map);
        this.loadPoints(this.points);
      }, 600);
    },

    loadPoints(points = []) {
      const L = window.L;
      this.pointLayers.forEach(l => l.remove());
      if (this.group) {
        this.group.remove();
      }

      points.forEach(point => {
        const layer = L.circleMarker(point.coords, {
          radius: 8,
          fill: true,
          fillColor: point.type === 1 ? "#00f" : "#f00",
          stroke: false,
          fillOpacity: 0.6,
        }).addTo(this.map);
        this.pointLayers.push(layer);
      });

      if (points.length > 0) {
        this.group = L.featureGroup(this.pointLayers);
        this.map.fitBounds(this.group.getBounds());
      }
    },
  },

  watch: {
    points(points) {
      this.loadPoints(points);
    },
  },
};
</script>

<style lang="scss" module>
.map {
  width: 100%;
  height: 100%;
}
</style>
